/**  This is a list of apps which have functionality in routing forms */
export const enabledAppSlugs = ["salesforce"];
